import { useState, useEffect } from 'react';
import { IconX } from '@tabler/icons-react';
import Skeleton from 'react-loading-skeleton';

import { rupiah } from 'lib/currency';
import { getImageUrl } from 'lib/getImageUrl';
import { findColorType } from 'lib/uiHelpers';

import SliderDate from 'components/SliderDate';
import ListSection from 'components/ListSection';
import ListCard from 'components/ListCard';

const ContentCardPass = ({ item, onClose, type }) => {
  const [pickDate, setPickDate] = useState(new Date());
  const [imageUrls, setImageUrls] = useState([]);
  const [loadingImages, setLoadingImages] = useState(true);

  useEffect(() => {
    const fetchImages = async () => {
      if (!Array.isArray(item?.images) || item.images.length === 0) {
        setImageUrls(['/kin/assest/image/icon-profile.png']);
        setLoadingImages(false);
        return;
      }

      try {
        setLoadingImages(true);
        const urls = await Promise.all(item.images.map((img) => getImageUrl(img)));
        setImageUrls(urls);
      } catch (error) {
        console.error('Error fetching images:', error);
        setImageUrls(['/kin/assest/image/icon-profile.png']);
      } finally {
        setLoadingImages(false);
      }
    };

    fetchImages();
  }, [item]);

  const findTitleCardType = (category, type) => {
    if (category === 0) {
      return type;
    } else if (category === 1) {
      return 'Exhibition + Play';
    } else {
      return 'Exhibition Only';
    }
  };

  if (type === 'view') {
    return (
      <div className="font-sans">
        <div className="bg-white rounded-2xl min-w-md w-96 relative text-kin-text flex flex-col gap-3 py-5">
          <button
            type="button"
            onClick={() => onClose(false)}
            className="absolute top-2 right-2 p-2">
            <IconX className="w-6 h-6" />
          </button>
          <div className="flex flex-col gap-2 px-6">
            <div className="font-light text-kin-text text-sm leading-none uppercase">
              {findTitleCardType(
                item?.category,
                item?.type.toLowerCase() === 'collaboration' ? item?.type : `${item?.type} PASS`,
              )}
            </div>
            <div className="font-semibold text-lg text-kin-text mb-0 block leading-none">
              {item.package_name ? item.package_name : '-'}
            </div>
            <div className="font-semibold text-base text-kin-text block leading-none">
              {item.price ? rupiah(item.price) : 'Rp 0'}
            </div>
          </div>
          <div className="relative px-5 w-full flex gap-2 snap-x snap-mandatory overflow-x-auto">
            {loadingImages ? (
              <div className="snap-center shrink-0">
                <Skeleton height={210} width={330} className="rounded-lg" />
              </div>
            ) : (
              imageUrls.map((imgSrc, idx) => (
                <div key={idx} className="snap-center shrink-0">
                  <div className="shrink-0 h-[210px] w-[330px] relative">
                    <img
                      alt={item?.images?.[idx]?.alt || `Image ${idx}`}
                      src={imgSrc}
                      className="absolute inset-0 h-full w-full object-cover rounded-lg bg-[#F3F2F0]"
                    />
                  </div>
                </div>
              ))
            )}
          </div>

          <div className="px-5 flex flex-col gap-3">
            <div className="flex flex-col gap-1">
              <div
                className={`px-3.5 py-0.5 w-max rounded-2xl ${findColorType(
                  item.type.toLowerCase(),
                )}`}>
                <span className="text-sm font-semibold text-white capitalize">
                  {item.type === 'Regular' || item.type === 'Special'
                    ? `${item.type} Class`
                    : item.type}
                </span>
              </div>
              {item.description ? (
                <div
                  className="leading-[normal] font-medium text-sm"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
              ) : (
                <p className="leading-[normal] font-medium text-sm"> - </p>
              )}
            </div>
            <div className="-mt-4">
              <ListCard item={item} />
            </div>
            <div className="flex flex-col gap-1">
              <span className="uppercase text-sm font-normal">What you will experience</span>
              <span className="font-normal gap-1 text-kin-text text-xs block">
                {item?.experience ? item?.experience : '-'}
              </span>
            </div>
            {/* <button className="bg-primary-main w-max text-white rounded-[100px] py-2 px-3 flex justify-center items-center">
              <span className="text-xs font-semibold block">BUY NOW</span>
            </button> */}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`${
        item.class ? 'w-[1000px]' : 'w-[700px]'
      } bg-kin-textsecondary rounded-lg relative text-kin-text flex flex-col gap-3 py-5 px-4`}>
      <h2 className="text-lg text-kin-text font-semibold">Select a Date to Play</h2>
      <SliderDate pickDate={pickDate} setPickDate={setPickDate} type="small" />
      <div className="-mt-8">
        {[...Array(1)].map((date, idx) => {
          return <ListSection key={idx} item={item} pickDate={pickDate} type={type} />;
        })}
      </div>
    </div>
  );
};

export default ContentCardPass;
